import { render, staticRenderFns } from "./SideBarLink.vue?vue&type=template&id=31f94b78&scoped=true&"
import script from "./SideBarLink.vue?vue&type=script&lang=js&"
export * from "./SideBarLink.vue?vue&type=script&lang=js&"
import style0 from "./SideBarLink.vue?vue&type=style&index=0&id=31f94b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f94b78",
  null
  
)

export default component.exports